module.exports = __webpack_public_path__ + "img/22_28.e4394b67.png";